import { defineStore } from 'pinia'

export const useSettingsPageStore = defineStore('settingsPage', {
  state: () => ({
    /**
     * We store the active tab because the tabs are used in the page as well as the layout.
     */
    activeTab: 0
  }),
  actions: {
    setActiveTab(index: number) {
      this.activeTab = index
    }
  }
})
